enum OnlineFormArea {
    ExitNoticeVeryLowWage = 'exit_notice_low_volume',
    ExitNoticeVestedBenefitsInstitution = 'exit_notice_vested_benefits_institution',
    VoluntaryContinuation = 'voluntary_continuation',
    CivilStateChange = 'civil_state_change',
}

export default OnlineFormArea;
